import React from 'react';

export default function Head() {
  return (
    <section>
      <h1>How would you like to add members?</h1>
    </section>
  );
}
